const lodash = require('lodash')
angular
  .module('surfsightApp.controllers')
  .controller('surfMp4PlayerController', [
    '$scope',
    '$timeout',
    '$interval',
    '$http',
    '$mdToast',
    function ($scope, $timeout, $interval, $http, $mdToast) {
      const videoData = $scope.videoData
      const videoElementId = `event-video-${videoData.id}`
      $scope.videoElementId = videoElementId
      $scope.displayOptions = {
        showDisplayOptions: true,
        varient: 'eventVideoOnly',
        fullScreen: true,
        playPause: true,
        closeVideo: true,
        download: true,
        progressBar: true,
        ...($scope.videoData.displayOptions || {})
      }
      $scope.videoPlayerState = {
        playStatus: false,
        sliderValue: 0,
        durationText: '00:00',
        currentTimeText: '00:00',
        title: videoData.title
      }
      const initPlayerControls = () => {
        const video = document.getElementById(videoElementId)
        if (video) {
          videoData.playbackRate &&
            (video.playbackRate = videoData.playbackRate)
          video.addEventListener(
            'timeupdate',
            () => {
              timeupdate()
              $scope.$apply()
            },
            false
          )
          video.addEventListener(
            'ended',
            () => {
              videoEnded()
              $scope.$apply()
            },
            false
          )
          video.addEventListener(
            'loadeddata',
            () => {
              timeupdate()
              $scope.$apply()
            },
            false
          )
        }
      }
      const timeupdate = () => {
        const video = document.getElementById(videoElementId)
        if (!video) return
        const { currentTime, duration } = video
        const sliderValue = currentTime * (100 / duration)
        const currentTimeText = moment()
          .startOf('day')
          .add(currentTime, 'seconds')
          .format('mm:ss')
        const durationText = moment()
          .startOf('day')
          .add(duration, 'seconds')
          .format('mm:ss')
        $scope.videoData.currentTime = currentTime
        $scope.videoPlayerState.sliderValue = sliderValue
        $scope.videoPlayerState.currentTimeText = currentTimeText
        $scope.videoPlayerState.durationText = durationText
        $scope.onVideoMetadataUpdate &&
          $scope.onVideoMetadataUpdate({
            videoMetadata: {
              videoElementId,
              currentTime,
              duration,
              sliderValue,
              currentTimeText,
              durationText
            }
          })
      }
      const videoEnded = () => {
        $scope.videoPlayerState.playStatus = false
      }

      $scope.updateProgressBarStaus = () => {
        const video = document.getElementById(videoElementId)
        if (!video) return
        const newCurrentTime =
          video.duration * ($scope.videoPlayerState.sliderValue / 100)
        video.currentTime = newCurrentTime
        timeupdate()
      }
      $scope.play_pause_video = function (eventurl) {
        const video = document.getElementById(videoElementId)
        if (!video) return
        if (video.paused) {
          video.play()
          $scope.videoPlayerState.playStatus = true
        } else {
          video.pause()
          $scope.videoPlayerState.playStatus = false
        }
      }
      let fullScreenTracker
      const goFullScreen = () => {
        try {
          const element = document.getElementById(`${videoElementId}-container`)
          for (const fullScreenProp of [
            'requestFullscreen',
            'mozRequestFullScreen',
            'webkitRequestFullscreen',
            'webkitEnterFullScreen',
            'msRequestFullscreen'
          ]) {
            if (element[fullScreenProp]) {
              element[fullScreenProp]()
              fullScreenTracker = $interval(() => {
                const currentFullScreenState =
                  document.fullScreen ||
                  document.mozFullScreen ||
                  document.webkitIsFullScreen ||
                  document.webkitFullscreenElement
                if (!currentFullScreenState) {
                  fullScreenTracker && $interval.cancel(fullScreenTracker)
                  fullScreenTracker = null
                  $scope.playerStatus &&
                    ($scope.playerStatus.fullScreen = false)
                }
              }, 1000)
            }
          }
        } catch (e) {
          console.error(e)
        }
      }
      const exitFullScreen = () => {
        for (const exitFullScreenProp of [
          'exitFullscreen',
          'mozCancelFullScreen',
          'webkitExitFullscreen',
          'msExitFullscreen'
        ]) {
          if (document[exitFullScreenProp]) {
            document[exitFullScreenProp]()
            break
          }
        }
      }
      const toggleFullScreen = () => {
        const currentFullScreenState =
          document.fullScreen ||
          document.mozFullScreen ||
          document.webkitIsFullScreen ||
          document.webkitFullscreenElement
        if (currentFullScreenState) {
          exitFullScreen()
          $scope.playerStatus.fullScreen = false
        } else {
          goFullScreen()
          $scope.playerStatus.fullScreen = true
        }
      }
      $scope.toggleFullScreen = toggleFullScreen
      const clearVideoSrc = () => {
        const video = document.getElementById(videoElementId)
        if (video) {
          video.src = ''
          video.load()
        }
      }
      const closePlayer = () => {
        clearVideoSrc()
      }
      $timeout(() => {
        initPlayerControls()
      }, 500)
      $scope.$on(
        'surfMp4Player.updateCurrentTime',
        lodash.debounce((e, data) => {
          const video = document.getElementById(videoElementId)
          if (!video || $scope.videoData.currentTime === undefined) return
          video.currentTime = data.currentTime
        }, 200),
        true
      )
      $scope.$on('$destroy', () => {
        closePlayer()
        fullScreenTracker && $interval.cancel(fullScreenTracker)
      })
    }
  ])
